import { useEffect, useState } from "react";
import { getFortalezaCurrentHourKey } from "../scheduleGridModel";

export function useAgendaClock(): string {
  const [hourKey, setHourKey] = useState(getFortalezaCurrentHourKey);

  useEffect(() => {
    setHourKey(getFortalezaCurrentHourKey());
    const timer = window.setInterval(() => {
      setHourKey(getFortalezaCurrentHourKey());
    }, 60_000);
    return () => window.clearInterval(timer);
  }, []);

  return hourKey;
}
